<template>
    <div class="msg">
        <div class="user-mes-box">
            <div class="user-mes-title" v-text="title"></div>
            <div class="user-mes" v-show="addNew">
                <div class="mes-tips" :title="shareTips" v-text="shareTips"></div>
                <div class="mes-list-box">
                    <ul class="list-items list-items-st cle">
                        <li v-for="(item,index) in header" :key="index" :title="item.text" v-text="item.text" :class="[item.class,'fl']"></li>
                    </ul>
                    <div class="mes-list">
                        <ul class="list-items items-st cle" v-for="(item,index) in list" :key="index">
                            <li :title="item[0].text" v-text="item[0].text" :class="[item[0].class,'fl']"></li>
                            <li :title="item[1].text" v-text="item[1].text" :class="[item[1].class,'fl']"></li>
                            <li :title="item[2].text" v-text="item[2].text" :class="[item[2].class,'fl']"></li>
                            <li :class="[item[3].class,'fl']">
                                <img v-if="isHs===0" :src="Change" alt="" @click="changeDevice(item[3].accountId,item[3].account,name,item[3].powers,item[3].weekdays,item[3].periods,item[3].shareMode,item[3].shareSub,item[3].channel)">
                            </li>
                            <li :class="[item[4].class,'fl']">
                                <img :src="Del" alt="" @click="cancelShare(item[4].accountId,item[4].account,name,item[4].powers,item[4].weekdays,item[4].periods)">
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="user-mes-btn cle" style="margin-top:10px;">
                    <button type="button" class="fl" style="width:120px;" @click="add" :title="addText" v-text="addText"></button>
                    <button type="button" class="fr" @click="cancle" :title="cancleText" v-text="cancleText"></button>
                </div>
            </div>
            <div class="user-mes" v-show="addNews">
                <div class="mes-tips" :title="shareMes" v-text="shareMes"></div>
                <div class="share-in cle">
                    <input type="text" class="user-mes-inp fl" maxlength="32" v-model="friend">
                    <button type="button" class="share-input-search fr" @click="searchFriend" :title="shareSearch" v-text="shareSearch"></button>
                </div>
                <div class="mes-list-box-add">
                    <ul class="list-items list-items-st cle">
                        <li v-for="(item,index) in addHeader" :key="index" :title="item.text" v-text="item.text" :class="[item.class,'fl']"></li>
                    </ul>
                    <div class="mes-list">
                        <ul class="list-items items-st cle" v-for="(item,index) in addList" :key="index">
                            <li :title="item[0].text" v-text="item[0].text" :class="[item[0].class,'fl']"></li>
                            <li :class="[item[1].class,'fl']">
                                <img :src="Shared" alt="" @click="shareDevice(item[1].account)">
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="user-mes-btn cle" style="margin-top:10px;">
                    <button type="button" class="fl" @click="back" :title="backText" v-text="backText"></button>
                    <button type="button" class="fr" @click="addCancle" :title="cancleText" v-text="cancleText"></button>
                </div>
            </div>
            <shareChild v-show="shChSH" :mes="shareSub" v-on:setConfig="setConfig" v-on:setCancel="setCancel"></shareChild>
        </div>
    </div>
</template>
<script>
import share from '../assets/js/share'
import shareChild from './shareChild'
export default {
    name:'ShareToFriend',
    components:{
        shareChild:shareChild
    },
    data(){
        return{
            title:this.lanNow.lan["K034_ShareDevice"],
            shareTips:this.lanNow.lan["K177_Share"],
            addText:this.lanNow.lan["K178_Add"],
            cancleText:this.lanNow.lan["K018_Cancel"],
            header:[
                {class:'list-items-1',text:this.lanNow.lan["K179_Friends"]},
                {class:'list-items-1',text:this.lanNow.lan["K023_DeviceName"]},
                {class:'list-items-1',text:this.lanNow.lan["K180_Status"]},
                {class:'list-items-1',text:this.lanNow.lan["K189_Modify"]},
                {class:'list-items-1',text:this.lanNow.lan["K139_cancelShare"]}
            ],
            list:[],
            listModel:[
                {class:'list-items-1',text:''},
                {class:'list-items-1',text:''},
                {class:'list-items-1',text:''},
                {class:'list-items-1',accountId:'',account:''},
                {class:'list-items-1',accountId:'',account:''}
            ],
            Change:'./static/img/change.png',
            Del:'./static/img/del.png',
            id:'',
            name:'',
            isHs:0,
            addNew:true,
            addNews:false,
            shareMes:this.lanNow.lan["K184_Mes"],
            friend:'',
            shareSearch:this.lanNow.lan["K185_Search"],
            addHeader:[
                {class:'list-items-2',text:this.lanNow.lan["K179_Friends"]},
                {class:'list-items-2',text:this.lanNow.lan["K163_Share"]}
            ],
            addList:[],
            addListModel:[
                {class:'list-items-2',text:''},
                {class:'list-items-2',accountId:'',account:'',name:'',power:'',weekdays:'',periods:''}
            ],
            backText:this.lanNow.lan["K186_Return"],
            Shared:'./static/img/share.png',
            shareStatus:[
                this.lanNow.lan['K196_Stay'],
                this.lanNow.lan['K181_Share'],
                this.lanNow.lan['K195_Ignored']
            ],
            shChSH:false,
            shareSub:'',
            mode:true
        }
    },
    methods:{
        add:function(){
            this.addNew=false;
            this.addNews=true;
            this.friend='';
            this.addList=[];
        },
        searchFriend:function(){
            if(this.friend===''){
                alert(this.lanNow.lan["K187_Empty"]);
                return false;
            };
            if(!(/@/g).test(this.friend)){
                alert(this.lanNow.lan["K188_NotAvailable"]);
                return false;
            };
            this.$emit('loadMsg',true);
            var sessionId=this.ajaxH.session;
            var oem=this.baseData.oem;
            var str=share.searchFriend({
                sessionId:sessionId,
                oem:oem,
                account:this.friend
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:str
            });
            this.searchResult(data.data);
        },
        searchResult:function(data){
            this.$emit('loadMsg',false);
            if(data===''){
                return false;
            };
            var result=$(data).find('result').text();
            if(result==='0'){
                this.$nextTick(function(){
                    var arr=[];
                    var status=$(data).find('status').text()-0;
                    var a=$.extend(true,[],this.addListModel);
                    var memo=$(data).find('memo-name').text();
                    var account=$(data).find('account').text();
                    if(memo===''||account===memo||account===this.ajaxH.user){
                        var name=account;
                    }else{
                        var name=memo;
                    };
                    a[0].text=name;
                    a[1].name=memo;
                    a[1].account=account;
                    a[1].accountId=$(data).find('account-id').text()-0;
                    if(status===1||a[1].accountId===0){
                        alert(this.lanNow.lan["K197_Search"]);
                    }else{
                        arr.push(a);
                    };
                    this.addList=arr;
                });
            }else if(result==='100100001'||result===''){
                this.ajaxH.repeat=this.searchFriend;
                this.$emit('refresh');
            }else{
                var key = this.promptInfo(result);
                alert(this.lanNow.lan[key] == undefined ? key : this.lanNow.lan[key]);
            };
        },
        shareDevice:function(user){
            if(user===this.ajaxH.user){
                alert(this.lanNow.lan["K198_SameUser"]);
                return false;
            };
            if(this.list.length){
                for(var i=0;i<this.list.length;i++){
                    var name=this.list[i][4].account;
                    if(user===name){
                        alert(this.lanNow.lan["K212_Share"]);
                        return false;
                    };
                };
            };
            this.ajaxH.repeat=function(){
                if(this.mode){
                    var str=share.deviceSharec({
                        sessionId:this.ajaxH.session,
                        oem:this.baseData.oem,
                        id:this.id,
                    });
                    var data=this.ajaxSet({
                        ip:this.cloudName,
                        type:'auth/user',
                        xml:JSON.stringify(str),
                        cType:'json'
                    });
                    data.data.content[0].profile.chns.total=1;
                    if(data.data.content[0].profile.chns.total-0>1){
                        this.shareDeviceResult(data.data);
                    }else if(data.data.content[0].profile.chns.total-0===1){
                        this.$emit('power',{
                            id:this.id,
                            isHs:this.isHs,
                            name:this.addList[0][1].name,
                            account:this.addList[0][1].account,
                            accountId:this.addList[0][1].accountId,
                            power:'1,3,4',
                            weekdays:'0,1,2,3,4,5,6',
                            periods:'00:00:00-23:59:59',
                            default:true,
                            isSub:false
                        });
                        this.addCancle();
                    };
                }
            }.bind(this);
            this.$emit('refresh');
        },
        shareDeviceResult:function(data){
            var obj=data;
            var list=obj.content[0]['sub-devlist'];
            var chA=[];
            for(var i=0;i<list.length;i++){
                chA.push((/\d+/).exec(list[i].code)[0]-0);
            };
            this.addNew=false;
            this.addNews=false;
            this.shareSub={
                id:this.id,
                isHs:this.isHs,
                name:this.addList[0][1].name,
                account:this.addList[0][1].account,
                accountId:this.addList[0][1].accountId,
                power:'1,3,4',
                weekdays:'0,1,2,3,4,5,6',
                periods:'00:00:00-23:59:59',
                default:true,
                isSub:true,
                total:chA
            };
            this.shChSH=true;
        },
        changeDevice:function(accountId,account,name,powers,weekdays,periods,mode,sub,channel){
            this.$emit('loadMsg',true);
            mode='';
            this.ajaxH.repeat=function(){
                if(mode==='subdev'){
                    this.addNew=false;
                    this.addNews=false;
                    var str=share.deviceSharec({
                        sessionId:this.ajaxH.session,
                        oem:this.baseData.oem,
                        id:this.id,
                    });
                    var data=this.ajaxSet({
                        ip:this.cloudName,
                        type:'auth/user',
                        xml:JSON.stringify(str),
                        cType:'json'
                    });
                    this.$emit('loadMsg',false);
                    var obj=data.data;
                    var list=obj.content[0]['sub-devlist'];
                    var chA=[];
                    for(var i=0;i<list.length;i++){
                        chA.push((/\d+/).exec(list[i].code)[0]-0);
                    };
                    this.shareSub={
                        id:this.id,
                        isHs:this.isHs,
                        name:name,
                        account:account,
                        accountId:accountId,
                        sub:sub,
                        default:false,
                        isSub:true,
                        power:'1,3,4',
                        weekdays:'0,1,2,3,4,5,6',
                        periods:'00:00:00-23:59:59',
                        total:chA
                    };
                    this.shChSH=true;
                }else if(mode==='whole'&&channel>1){
                    var str=share.deviceSharec({
                        sessionId:this.ajaxH.session,
                        oem:this.baseData.oem,
                        id:this.id,
                    });
                    var data=this.ajaxSet({
                        ip:this.cloudName,
                        type:'auth/user',
                        xml:JSON.stringify(str),
                        cType:'json'
                    });
                    this.addNew=false;
                    this.addNews=false;
                    this.$emit('loadMsg',false);
                    var chA=[];
                    for(var i=1;i<channel+1;i++){
                        chA.push(i);
                    };
                    this.shareSub={
                        id:this.id,
                        isHs:this.isHs,
                        name:name,
                        account:account,
                        accountId:accountId,
                        power:powers,
                        weekdays:weekdays,
                        periods:periods,
                        default:true,
                        isSub:true,
                        total:chA,
                        shared:true
                    };
                    this.shChSH=true;
                }else{
                    this.$emit('loadMsg',false);
                    this.$emit('power',{
                        id:this.id,
                        isHs:this.isHs,
                        name:name,
                        account:account,
                        accountId:accountId,
                        power:powers,
                        weekdays:weekdays,
                        periods:periods,
                        default:false,
                        isSub:false
                    });
                    this.addCancle();
                };
            }.bind(this);
            this.$emit('refresh');
        },
        setConfig:function(obj){
            this.shChSH=false;
            this.addCancle();
            this.$emit('power',{
                id:obj.id,
                ch:obj.ch,
                isHs:obj.isHs,
                name:obj.name,
                account:obj.account,
                accountId:obj.accountId,
                power:obj.power,
                weekdays:obj.weekdays,
                periods:obj.periods,
                default:false,
                isSub:true
            });
        },
        back:function(){
            this.addNew=true;
            this.addNews=false;
            this.$emit('loadMsg',true);
            this.getList();
        },
        addCancle:function(){
            this.cancle();
            this.addNew=true;
            this.addNews=false;
        },
        init:function(data){
            this.$emit('loadMsg',true);
            this.id=data.id;
            this.name=data.name;
            this.isHs=data.isHs;
            this.getList();
        },
        getList:function(){
            this.shChSH=false;
            this.list=[];
            var arr=[];
            this.shareSub='';
            this.shareList.list.forEach(function(el,idx){
                if(this.id===el.cloudId){
                    var a=$.extend(true,[],this.listModel);
                    a[0].text=el.account===el.nikeName?el.account:el.nikeName;
                    a[1].text=this.name;
                    a[2].text=this.shareStatus[el.status];
                    a[4].accountId=a[3].accountId=el.accountId;
                    a[4].account=a[3].account=el.account;
                    a[4].powers=a[3].powers=el.powers;
                    a[4].weekdays=a[3].weekdays=el.weekdays;
                    a[4].periods=a[3].periods=el.periods;
                    a[4].shareMode=a[3].shareMode=el.shareMode;
                    a[4].channel=a[3].channel=el.channel;
                    a[4].shareSub=a[3].shareSub=el.shareSub;
                    arr.push(a);
                };
            }.bind(this));
            this.list=arr;
            this.$emit('loadMsg',false);
            return false;
            var sessionId=this.ajaxH.session;
            var oem=this.baseData.oem;
            var str=share.deviceShare({
                sessionId:sessionId,
                oem:oem,
                id:this.id,
                isHs:this.isHs
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:str
            });
            this.getListResult(data.data);
        },
        getListResult:function(data){
            this.$emit('loadMsg',false);
            if(data===''){
                return false;
            };
            var result=$(data).find('result').text();
            if(result==='0'){
                var arr=[];
                var _that=this;
                $(data).find('item').each(function(){
                    var a=$.extend(true,[],_that.listModel);
                    a[0].text=$(this).find('account').text()===$(this).find('memo-name').text()?$(this).find('account').text():$(this).find('memo-name').text();
                    a[1].text=_that.name;
                    a[2].text=_that.shareStatus[$(this).find('share-state').text()-0];
                    a[4].accountId=a[3].accountId=$(this).find('account-id').text();
                    a[4].account=a[3].account=$(this).find('account').text();
                    a[4].powers=a[3].powers=$(this).find('powers').text();
                    a[4].weekdays=a[3].weekdays=$(this).find('weekdays').text();
                    a[4].periods=a[3].periods=$(this).find('periods').text();
                    arr.push(a);
                    // arr.push({
                    //     name:$(this).find('memo-name').text(),
                    //     account:$(this).find('account').text(),
                    //     accountId:$(this).find('account-id').text(),
                    //     status:$(this).find('status').text()-0
                    // });
                });
                this.list=arr;
                this.ajaxH.repeat=function(){};
            }else if(result==='100100001'||result===''){
                this.ajaxH.repeat=this.getList;
                this.$emit('refresh');
            }else{
                var key = this.promptInfo(result);
                alert(this.lanNow.lan[key] == undefined ? key : this.lanNow.lan[key]);
            };
            
        },
        cancelShare:function(accountId,account){
            this.ajaxH.repeat=function(){
                this.cancelShareAfter(accountId,account);
            }.bind(this);
            this.$emit('refresh');
        },
        cancelShareAfter:function(accountId,account){
            var cancelStr=share.cancelShareSet({
                sessionId:this.ajaxH.session,
                oem:this.baseData.oem,
                accountId:accountId,
                account:account,
                id:this.id,
                isHs:this.isHs
            });
            var data=this.ajaxSet({
                ip:this.cloudName,
                type:'auth/user',
                xml:cancelStr
            });
            this.cancelShareResult(data.data);
        },
        cancelShareResult:function(data){
            var result=$(data).find('result').text();
            if(result === "0"){
                alert(this.lanNow.lan['K183_Cancel']);
                this.$emit('refresh');
            }else{
                var key = this.promptInfo(result);
                alert(this.lanNow.lan[key] == undefined ? key : this.lanNow.lan[key]);
            };
            this.$emit('loadMsg',true);
            this.getList();
        },
        cancle:function(){
            this.$emit('close');
        },
        setCancel:function(data,accountId,id){
            this.$emit('loadMsg',true);
            var arr=data;
            this.ajaxH.repeat=function(){
                var itemA=[];
                arr.forEach(function(v){
                    itemA.push({
                        subcode:'ch'+v.ch,
                        weekdays:v.weekdays,
                        periods:v.periods,
                        powers:v.power,
                    });
                });
                var timeStr=share.subdevShare({
                    sessionId:this.ajaxH.session,
                    oem:this.baseData.oem,
                    accountId:accountId,
                    id:id,
                    item:itemA
                });
                var data=this.ajaxSet({
                    ip:this.cloudName,
                    type:'auth/user',
                    xml:JSON.stringify(timeStr),
                    cType:'json'
                });
                var result=data.data.header.result-0;
                this.$emit('loadMsg',false);
                if( result=== 0){
                    alert(this.lanNow.lan['K183_Cancel']);
                    this.$emit('refresh');
                }else{
                    var key = this.promptInfo(result);
                    alert(this.lanNow.lan[key] == undefined ? key : this.lanNow.lan[key]);
                };
                this.addCancle();
            }.bind(this);
            this.$emit('refresh');
        }
    }
}
</script>
<style scoped>
    .msg{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background-color:rgba(0, 0, 0, .5);
    }
    .user-mes-box{
        width:540px;
        height:auto;
        background-color: #EFF2F9;
        font-size:12px;
        position:absolute;
        left:50%;
        margin-top:160px;
        margin-left:-240px;
    }
    .user-mes-title{
        width:100%;
        height:24px;
        line-height:24px;
        text-align: center;
        background-color: #364860;
        color:#fff;
    }
    .user-mes{
        width:100%;
        height:300px;
        padding:20px;
        box-sizing: border-box;
    }
    .mes-tips{
        width:100%;
        height:30px;
        line-height:30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
    }
    .mes-list-box{
        width:100%;
        height:calc(100% - 30px - 40px);
        border: 1px solid #ccc;
        box-sizing: border-box;
    }
    .mes-list-box-add{
        width:100%;
        height:calc(100% - 30px - 40px - 40px);
        border: 1px solid #ccc;
        box-sizing: border-box;
        margin-top:10px;
    }
    .list-items{
        width:100%;
        height:30px;
        border-bottom: 1px solid #ccc;
        background-color: #7F8B9B;
        color:#fff;
    }
    .list-items-1{
        width:99px;
        height:100%;
        line-height:30px;
        text-align: center;
        border-left:1px solid #ccc;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        box-sizing: border-box;
    }
    .list-items .list-items-1:first-child{
        border-left: none;
    }
    .list-items .list-items-1:last-child{
        width:calc(100% - 4 * 99px);
    }
    .list-items-2{
        width:248px;
        height:100%;
        line-height:30px;
        text-align: center;
        border-left:1px solid #ccc;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        box-sizing: border-box;
    }
    .list-items .list-items-2:first-child{
        border-left: none;
    }
    .list-items .list-items-2:last-child{
        width:calc(100% - 248px);
    }
    .mes-list{
        width:100%;
        height:calc(100% - 30px);
        overflow: hidden;
        overflow-y: auto;
    }
    .mes-list .list-items{
        background-color: transparent;
        color:#000;
    }
    .list-items img{
        width:18px;
        height:18px;
        margin-top:4px;
        cursor: pointer;
    }
    .share-in{
        width:100%;
        height:30px;
    }
    .user-mes-inp{
        width:calc(100% - 100px);
        height:100%;
        box-sizing: border-box;
        border:1px solid #ccc;
        outline: none;
    }
    .share-input-search{
        width:80px;
        height:100%;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        cursor: pointer;
    }
    .user-mes-btn{
        width:100%;
        height:30px;
    }
    .user-mes-btn button{
        width:80px;
        height:100%;
        background-color: #EFF2F9;
        box-sizing: border-box;
        border:1px solid #364860;
        outline: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
        cursor: pointer;
    }
</style>
<style scoped>
    @import '../assets/css/cloudPop.css';  
</style>


// WEBPACK FOOTER //
// src/components/ShareToFriends.vue